import { render } from "./EntitySelectorCliente.vue?vue&type=template&id=790cfddd"
import script from "./EntitySelectorCliente.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorCliente.vue?vue&type=script&lang=ts"
script.render = render

export default script